<template>
  <div>
    <h2 v-t="'projectSettings'" class="text-2xl font-weight-semibold mb-4" />
    <v-card id="account-setting-card">
      <v-tabs v-model="currentTab" show-arrows>
        <v-tab v-for="tab in tabs" :key="tab.icon">
          <v-icon size="20" class="me-3">
            {{ tab.icon }}
          </v-icon>
          <span>{{ $t(tab.title) }}</span>
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="currentTab" touchless>
        <v-tab-item v-if="$can(ACTIONS.READ, PRIVATE.SETTINGS.PROJECTS)">
          <project-settings-tab-statuses />
        </v-tab-item>
        <v-tab-item v-if="$can(ACTIONS.READ, PRIVATE.SETTINGS.PROJECTS)">
          <project-settings-tab-custom-fields />
        </v-tab-item>
        <v-tab-item v-if="$can(ACTIONS.READ, PRIVATE.SETTINGS.PROJECTS)">
          <project-settings-tab-tags />
        </v-tab-item>
        <v-tab-item v-if="$can(ACTIONS.READ, PRIVATE.SETTINGS.PROJECTS)">
          <project-settings-tab-house-rates-categories />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import { mdiText, mdiTagOutline, mdiBookEditOutline, mdiTimetable } from '@mdi/js'
// eslint-disable-next-line object-curly-newline
import ProjectSettingsTabStatuses from './project-settings-tab-statuses/ProjectSettingsTabStatuses.vue'
import ProjectSettingsTabCustomFields from './project-settings-tab-custom-fields/ProjectSettingsTabCustomFields.vue'
import ProjectSettingsTabTags from './project-settings-tab-tags/ProjectSettingsTabTags.vue'
import ProjectSettingsTabHouseRatesCategories from './project-settings-tab-house-rates-categories/ProjectSettingsTabHouseRatesCategories.vue'
import { ACTIONS, PRIVATE } from '@/plugins/acl/const'

export default {
  components: {
    ProjectSettingsTabStatuses,
    ProjectSettingsTabCustomFields,
    ProjectSettingsTabTags,
    ProjectSettingsTabHouseRatesCategories,
  },
  setup() {
    const currentTab = ref(null)
    const tabs = [
      { icon: mdiText, title: 'statuses' },
      { icon: mdiBookEditOutline, title: 'customFields' },
      { icon: mdiTagOutline, title: 'tags' },
      { icon: mdiTimetable, title: 'hourlyRatesCategory' },
    ]

    return {
      tabs,
      currentTab,

      ACTIONS,
      PRIVATE,
    }
  },
}
</script>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';
</style>
